<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">资产对账</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <span class="label">期间：</span>
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <Button color="primary" size="s" @click="loadData">查询</Button>
            <Button size="s" @click="printPage">打印</Button>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:120px">项目</th>
                    <th style="min-width:180px">名称</th>
                    <th style="width:150px">期初余额</th>
                    <th style="width:150px">借方</th>
                    <th style="width:150px">贷方</th>
                    <th style="width:150px">余额</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in rows" :key="i" :class="{diff: item.type === 'diff'}">
                    <td>{{item.item}}</td>
                    <td>{{item.name}}</td>
                    <td align="right" :class="{red: isDiff(item, 'beginBalance')}">{{item.beginBalance|numFormat}}</td>
                    <td align="right" :class="{red: isDiff(item, 'debit')}">{{item.debit|numFormat}}</td>
                    <td align="right" :class="{red: isDiff(item, 'credit')}">{{item.credit|numFormat}}</td>
                    <td align="right" :class="{red: isDiff(item, 'balance')}">{{item.balance|numFormat}}</td>
                </tr>
                <tr v-if="!rows.length">
                    <td colspan="6" class="text-center padding">暂无数据</td>
                </tr>
                </tbody>
            </table>
            <div class="padding-15 text-gray" v-if="rows.length">
                说明：「会计科目」为总账余额，「资产卡片」为固定资产台账数据，「差异」= 资产卡片 − 会计科目，均为 0 表示账实相符。
            </div>
        </div>
    </app-content>
</template>

<script>
export default {
    name: 'AssetsCheck',
    data() {
        const now = new Date();
        return {
            rows: [],
            p1: now,
            p2: now
        };
    },
    methods: {
        fmtPeriod(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        },
        loadData() {
            this.$api.assets.assets.check({
                p1: this.fmtPeriod(this.p1),
                p2: this.fmtPeriod(this.p2)
            }).then(({ data }) => {
                this.rows = (data && data.rows) || [];
            });
        },
        isDiff(item, field) {
            return item.type === 'diff' && Math.abs(Number(item[field] || 0)) >= 0.01;
        },
        printPage() { window.print(); }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style scoped lang="less">
    .filter-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;

        .label { margin-left: 6px; }
    }

    .grid {
        width: 100%;
        border-collapse: collapse;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        tbody tr:hover { background-color: #f0f6ff; }

        .diff td { background-color: #fafafa; font-weight: bold; }

        .red { color: #d0021b; }
    }
</style>
